export const CONVERSATIONS_LIST_LIMIT = 10
export const CONVERSATIONS_LIST_FULL_LIMIT = 100
